import React from 'react';
import { ArrowRight, Star } from 'lucide-react';
import { heroStats, heroImage, brand } from '../../mock';

const Hero = () => {
  return (
    <section id="top" className="relative pt-10 pb-16 lg:pt-16 lg:pb-24 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7 reveal">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[var(--brand-cream-2)] border border-[rgba(31,58,46,0.1)] text-xs uppercase tracking-[0.18em] text-[var(--brand-green-2)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--brand-gold)]" />
            Root Cause · Real Solutions · Lasting Health
          </div>

          <h1 className="font-serif mt-6 text-[46px] leading-[1.02] tracking-tight text-green sm:text-[64px] lg:text-[84px]">
            The science <em className="italic text-[var(--brand-gold)]">of</em>{' '}
            <br className="hidden sm:block" />
            living well.
          </h1>

          <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-[var(--brand-mute)]">
            A state-of-the-art, evidence-based approach to better health and lifestyle — delivered by a premium clinical team who see the whole person, not just the symptom.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a href={brand.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
              Book a consultation <ArrowRight size={16} />
            </a>
            <a href="#pathways" className="btn-outline">Explore care model</a>
          </div>

          <div className="mt-10 flex items-center gap-6">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} className="fill-[var(--brand-gold)] stroke-[var(--brand-gold)]" />
              ))}
            </div>
            <span className="text-sm text-[var(--brand-mute)]">
              Trusted by 1,000+ Australians on their health journey
            </span>
          </div>
        </div>

        <div className="lg:col-span-5 reveal">
          <div className="relative aspect-[4/5] rounded-[28px] overflow-hidden border border-[rgba(31,58,46,0.08)] bg-[var(--brand-cream-2)]">
            <video
              src="https://customer-assets.emergentagent.com/job_elevate-refresh-1/artifacts/emj7ltuh_hf_20260708_150838_2f3b6be2-9fbf-4a23-9a1d-766e782967aa%20%281%29.mp4"
              className="h-full w-full object-cover"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              poster={heroImage}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[rgba(31,58,46,0.35)] via-transparent to-transparent pointer-events-none" />
            <div className="absolute left-5 bottom-5 right-5 bg-[rgba(247,243,236,0.92)] backdrop-blur rounded-2xl p-4 flex items-center justify-between border border-[rgba(31,58,46,0.08)]">
              <div>
                <div className="text-[11px] uppercase tracking-[0.18em] text-[var(--brand-mute)]">Personalised care plan</div>
                <div className="font-serif text-green text-lg mt-0.5">Built around your data</div>
              </div>
              <div className="h-10 w-10 rounded-full bg-[var(--brand-green)] text-[var(--brand-cream)] grid place-items-center">
                <ArrowRight size={16} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-10 mt-16 lg:mt-24 grid grid-cols-2 sm:grid-cols-4 gap-6 lg:gap-10 border-t border-[rgba(31,58,46,0.1)] pt-10 reveal">
        {heroStats.map((s) => (
          <div key={s.label}>
            <div className="font-serif text-4xl lg:text-5xl text-green tracking-tight">{s.value}</div>
            <div className="mt-2 text-xs uppercase tracking-[0.18em] text-[var(--brand-mute)]">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
